<template>
    <b-nav class="w-100 flex-lg-column" id="tests_nav">
        <b-nav-item :active="$parent.currentStepNumber == 1" :disabled="true">{{ $t('tests.wizard.steps.image') }}</b-nav-item>
        <b-nav-item :active="$parent.currentStepNumber == 2" :disabled="true">{{ $t('tests.wizard.steps.area') }}</b-nav-item>
        <b-nav-item :active="$parent.currentStepNumber == 3" :disabled="true">{{ $t('tests.wizard.steps.testers') }}</b-nav-item>
        <b-nav-item :active="$parent.currentStepNumber == 4" :disabled="true">{{ $t('tests.wizard.steps.payment') }}</b-nav-item>
        <b-nav-item :active="$parent.currentStepNumber == 5" :disabled="true">{{ $t('tests.wizard.steps.summary') }}</b-nav-item>
    </b-nav>
</template>

<script>
    export default {
        name: 'tests-nav',
        methods: {

        },
        computed: {

        }
    }
</script>

<style scoped>

</style>
